<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-input v-model="query.orderType.name" clearable placeholder="business.label.orderType" size="small" type="search" @search-click="refresh"/>
      <vxe-input v-model="query.role.name" clearable placeholder="business.label.roleName" size="small" type="search" @search-click="refresh"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      :height="height"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :cell-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('orderTypeModal',{available:true},row)}}" field="orderType.name" title="business.label.orderType"/>
      <vxe-column :cell-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('roleModal',{available:true},row)}}" field="role.name" title="business.label.role"/>
      <vxe-column :cell-render="{name:'VxeNumberInput',autoSelect:true,props:{min:1}}" field="ordinal" title="business.label.ordinal"/>
      <vxe-column :cell-render="{name:'VxeSelect',options:flowTypes}" field="flowType" title="business.label.flowType"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <order-type-modal ref="orderTypeModal" @change="(e,row)=>this.changeOrderType(row,e[0])"/>
    <role-modal ref="roleModal" @change="(e,row)=>this.changeRole(row,e[0])"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { findAll, findEnum, saveAll } from '@/api/Api'
import { ENTERPRISE, SCREEN_HEIGHT } from '@/store/mutation-types'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import RoleModal from '@/views/modal/RoleModal.vue'
import { OrderType } from '@/api/dto/common/OrderType'
import { Role } from '@/api/dto/admin/Role'
import { ApprovalConfig } from '@/api/dto/config/ApprovalConfig'

export default {
  name: 'ApproveConfig',
  components: {
    OrderTypeModal,
    RoleModal
  },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      data: [],
      query: new ApprovalConfig(),
      page: 1,
      size: 20,
      contentSize: 0,
      flowTypes: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
      editRules: {
        'orderType.name': [
          { required: true, type: 'string', message: '订单类型不能为空' }
        ],
        'role.name': [
          { required: true, type: 'string', message: '角色不能为空' }
        ],
        ordinal: [
          { required: true, type: 'number', message: '顺序不能为空' }
        ]
      }
    }
  },
  created() {
    findEnum('FlowType').then(res => {
      if (res.success) {
        this.flowTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('approvalConfigFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new ApprovalConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    openModal(modal, args, e) {
      this.$refs[modal].open(args, e)
    },
    changeOrderType(row, record) {
      row.orderType = new OrderType(record)
    },
    changeRole(row, record) {
      row.role = new Role(record)
    },
    add() {
      this.data.push(new ApprovalConfig())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.enterprise = this.enterprise
          return item.toJSONObject()
        })
        saveAll('approvalConfigPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>